export default __webpack_public_path__ + "static/media/gestao_1.54bea102.png";